import React from "react";
import { Container, Row } from "reactstrap";
import PropTypes from "prop-types";

class Footer extends React.Component {
    render() {
        return (
            <footer className={"footer" + (this.props.default ? " footer-default" : "")}>
                <Container fluid={this.props.fluid ? true : false}>
                    <Row>
                        <nav className="footer-nav">
                            <ul>
                                <li>
                                    <a href="https://fitideas.co">
                                        Powered by <b>Fit Ideas</b>
                                        </a>
                                </li>
                                {/* <li>
                                    <a href="https://fitideas.co">
                                        Blog
                                    </a>
                                </li>
                                <li>
                                    <a href="https://fitideas.co">
                                        Docs
                                    </a>
                                </li> */}
                            </ul>
                        </nav>
                        {/* <div className="credits ml-auto">
                            <div className="copyright">
                                &copy; {1900 + new Date().getYear()}, made with{" "}
                                <i className="fa fa-heart heart" /> by Fit Ideas
                            </div>
                        </div> */}
                    </Row>
                </Container>
            </footer>
        );
    }
}

Footer.propTypes = {
    default: PropTypes.bool,
    fluid: PropTypes.bool
};

export default Footer;
